module.exports = __webpack_public_path__ + "img/ミッション.b06b7792.png";